import { createGenericFormSlice, SliceState } from "./genericFormSlice";

export interface Register {
  email: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
}

const formSlice = createGenericFormSlice({
  name: "register",
  initialState: {} as SliceState<Register>,
  reducers: {},
});

export const { reset, initialize, updateField } = formSlice.actions;
const registerFormReducer = formSlice.reducer;
export default registerFormReducer;
